import axios from 'axios';
import { REST_SERVICE_URL_ROOT, URL_ROOT} from '../config/settings';
import * as actions from '../views/containers/Login/state/actions';
import configureStore from '../store/store';

let store =  configureStore()

class ApiService {
  constructor() {
    
    axios.defaults.baseURL = REST_SERVICE_URL_ROOT;
    
    let service = axios.create();
    service.interceptors.request.use(function (config) {
        store.dispatch(actions.hideShowLoader(true))
        return config;
      
    }, function (error) {
      this.handleError(error)
      return Promise.reject(error);
    });

    service.interceptors.response.use(this.handleSuccess, this.handleError);
    
    this.service = service;
  }

  handleSuccess(response) {
    store.dispatch(actions.hideShowLoader(false))
    return response;
  }


  handleError = (error) => {    
    store.dispatch(actions.hideShowLoader(false))
    error = JSON.parse(JSON.stringify(error));
    const status = error.response ? error.response.status : null;
    let path = document.location.origin+"/"+URL_ROOT+"/";
    switch (status) {
      case 401:
          if(document.location.href!==path+status){
            this.redirectTo(path+status);
          }
        break;
      case 404:
        console.error(error);
        break;
      default:
        console.error(error);
        break;
    }
    return Promise.reject(error);
  }

  redirectTo = (path) => {
    document.location = path;
  }

  api_get(path,payload) {
    return this.service.request({
      method: 'GET',
      url: path,
      responseType: 'json',
      data: payload,
      timeout: 10000
    }).then((response) => {return response})
  }

  get(path,payload) {
    return this.service.request({
      method: 'POST',
      url: path+"/list",
      responseType: 'json',
      data: payload
    }).then((response) => {return response})
  }

  post(path,payload, file) {
    return this.service.request({
      method: 'POST',
      url: path,
      responseType: file?'arraybuffer':'json',
      data: payload
    }).then((response) => {return response})
  }

  view(path,payload) {
    return this.service.request({
      method: 'POST',
      url: path+("/"+payload),
      responseType: 'json',
    }).then((response) => {return response})
  } 

  add(path,payload) {
    return this.service.request({
      method: 'POST',
      url: path+"/add",
      responseType: 'json',
      data: payload
    }).then((response) => {return response})
  }

  update(path,payload) {
    return this.service.request({
      method: 'POST',
      url: path+"/update",
      responseType: 'json',
      data: payload
    }).then((response) => {return response})
    .catch((e)=> this.handleError(e));
  }

  delete(path, payload) {
    return this.service.request({
      method: 'DELETE',
      url: path+"/delete/"+payload,
      responseType: 'json'
    }).then((response) => {return response})
    .catch((e)=> this.handleError(e));
  }

  deleteByKey(path, key) {
    return this.service.request({
      method: 'DELETE',
      url: path+"/delete",
      responseType: 'json',
      data: key
    }).then((response) => {return response})
    .catch((e)=> this.handleError(e));
  }
}

export default new ApiService();